import { Outlet } from 'react-router-dom';
import { useWebSocket } from '../../hooks/useWebSocket';
import { cleanupConnectionEvents, initializeConnectionEvents } from '../../api/events/connectionEvents';
import { useEffect } from 'react';
import { PlayerContext } from '../PlayerContext';

export const PlayerConnectionWrapper = () => {
  useWebSocket();
  useEffect(() => {
    initializeConnectionEvents();
    return () => {
      cleanupConnectionEvents();
    };
  }, []);
  return (
    <PlayerContext>
      <Outlet />
    </PlayerContext>
  );
};
